import { useSearchParams } from "react-router-dom";
import { GradientLayout } from "../common/DefaultLayout";
import LandingHero from "./LandingHero";
import { LandingSection } from "./LandingSection";
import { getRoundSelectionParamsFromUrlParams, useFilterRounds } from "./hooks/useFilterRounds";
import { RoundsFilter } from "./RoundsFilter";
import { getExplorerPageTitle } from "./utils/getExplorerPageTitle";
import { RoundsGrid } from "./RoundsGrid";
import { getEnabledChains } from "../../app/chainConfig";
import { useMemo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ExploreRoundsPage = () => {
  var _rounds$data$length, _rounds$data2;
  const [params] = useSearchParams();
  const filter = getRoundSelectionParamsFromUrlParams(params);
  // Pass the filter from the search params and build the graphql query
  const rounds = useFilterRounds(filter, getEnabledChains(), filter.status.includes("verified"));
  const publicRounds = useMemo(() => {
    var _rounds$data;
    return (_rounds$data = rounds.data) === null || _rounds$data === void 0 ? void 0 : _rounds$data.filter(round => {
      var _round$roundMetadata$;
      return round.roundMetadata && round.roundMetadata.roundType && ((_round$roundMetadata$ = round.roundMetadata.roundType) === null || _round$roundMetadata$ === void 0 ? void 0 : _round$roundMetadata$.toLowerCase()) !== "private";
    });
  }, [rounds]);
  rounds.data = publicRounds;
  const sectionTitle = getExplorerPageTitle(filter);
  return /*#__PURE__*/_jsxs(GradientLayout, {
    showWalletInteraction: true,
    children: [/*#__PURE__*/_jsx(LandingHero, {}), /*#__PURE__*/_jsx(LandingSection, {
      title: `${sectionTitle} (${(_rounds$data$length = rounds === null || rounds === void 0 || (_rounds$data2 = rounds.data) === null || _rounds$data2 === void 0 ? void 0 : _rounds$data2.length) !== null && _rounds$data$length !== void 0 ? _rounds$data$length : 0})`,
      className: "flex-wrap",
      action: /*#__PURE__*/_jsx(RoundsFilter, {}),
      children: /*#__PURE__*/_jsx(RoundsGrid, {
        ...rounds,
        loadingCount: 6,
        roundType: "all"
      })
    })]
  });
};
export default ExploreRoundsPage;